<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <MapView />
</template>

<script>
import MapView from './components/MapView.vue'

export default {
  name: 'App',
  components: {
    MapView
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff; /*#2c3e50*/
  background-color: #1f2937;
  width: 100%;
  height: 100vh;
  display: flex;
  overflow: hidden;
}

.map-holder {
  width: 100%;
  height: 100vh;
  position: relative;
  background-color: #ccc;
}
.map-holder div:first-child {
  height: 100%;
}

.stats-holder {
  width: 600px;
  height: 100vh;
  position: relative;
  padding: 20px;
}

.space {
  height: 40px;
}

.text-right {
  text-align: right;
}

table {
  width: 100%;
}
td {
  padding: 3px 0;
  font-size: 20px;
}

h2 {
  border-bottom: solid 2px;
}
</style>
